import useTranslation from "../../hooks/useTranslation";
import { Modal } from "../../lib/modal";
import DeleteAccountForm from "../DeleteAccountForm/DeleteAccountForm";

export default function DeleteAccountModal({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) {
  const { t, m } = useTranslation();
  return (
    <Modal
      open={open}
      title={t(m.Account.DeleteAccount.Title)}
      size="small"
      onClose={onClose}
      telemetryName="delete_account"
    >
      <DeleteAccountForm open={open} />
    </Modal>
  );
}
